export default {
  title: 'Gérez votre établissement depuis partout',
  description: 'Connectez-vous à votre compte existant.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: "Saisir l'e-mail",
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Saisir le mot de passe',
    },
    error_messages: {
      missing_info: 'Informations manquantes',
      wrong_credentials: 'E-mail ou mot de passe incorrect',
    },
  },
  buttons: {
    login: 'Connexion',
    forgot_password: 'Mot de passe oublié',
  },
  white_label: {
    title: 'Accéder à votre tableau de bord',
    form: {
      email: {
        label: 'Adresse e-mail',
        placeholder: 'vous@restaurant.com',
      },
      password: {
        label: 'Mot de passe',
        placeholder: 'Saisir votre mot de passe',
      },
    },
    buttons: {
      login: 'Se connecter',
    },
    intro: {
      eyebrow: 'Gestion des commandes',
      headline: 'Gérez votre restaurant depuis partout.',
      description: 'Commandes, menus, horaires et virements — tout en un seul endroit.',
      features: {
        live: {
          title: 'En direct',
          subtitle: 'suivi des commandes',
        },
        instant: {
          title: 'Instantané',
          subtitle: 'modifications du menu',
        },
        any_device: {
          title: "N'importe quel appareil",
          subtitle: 'téléphone ou tablette',
        },
      },
    },
  },
};
